export default __webpack_public_path__ + "static/rsz_1hkrs_logotype_clean_on_light-a91ad2593ee5d07a145608b4a99f0e1c.png";